import { Post, PostPatchProps, Status } from './fetchRefactoredSchema'
import { useCallback } from 'react'
import useFetchRefactored from './useFetchRefactored'

export default function usePost<T, P>(props: PostPatchProps<T, P>): [Post<T>, Status<T>] {
  const { errorMessage, successMessage, emptyValue, configMapper } = props
  const [request, status] = useFetchRefactored({ errorMessage, successMessage, emptyValue })
  const post = useCallback(
    async (params: any) => {
      const { url, onSuccess, onError, config } = configMapper(params)
      return request({
        method: 'post',
        url,
        onError,
        onSuccess,
        config,
      })
    },
    [request, configMapper],
  )
  return [post, status]
}
